import React from 'react';
import { TableCell } from '@mui/material';
import SortingColumn from '#component/table/sorting-column';
import {
  ThStatusCell,
  TitleWithSubtitle
} from '#component/shipment/dashboard/table-view/styles';

export const ShipmentStatusCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    id="status"
    title="Status"
    width={60}
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
    CellComponent={ThStatusCell}
  />
);

export const ShipmentAlertCell = () => (
  <TableCell className="th">
    Alert
  </TableCell>
);

export const ShipmentLabelCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    id="label"
    title="Shipment"
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

export const ShipmentDevicesCell = () => (
  <TableCell className="th">Devices</TableCell>
);

export const ShipmentProjectCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    id="project"
    title="Project"
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

export const ShipmentStartDateCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    id="startDate"
    title={
      <TitleWithSubtitle>
        <div>Start</div>
        <div>From</div>
      </TitleWithSubtitle>
    }
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

export const ShipmentEndDateCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    id="endDate"
    title={
      <TitleWithSubtitle>
        <div>Due</div>
        <div>To</div>
      </TitleWithSubtitle>
    }
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

export const ShipmentDownloadCell = () => (
  <TableCell />
);
